<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-lg-8">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else><i class="far fa-money-check-alt m-r-sm"></i> Payment #{{ paymentDecorated.xero_number }}</h1>
        </div>
        <div class="col-sm-4 col-lg-4" v-if="notLoading">
          <p v-if="!paymentDecorated.isPaid" class="invoice-due">Paid: {{ paymentDecorated.paid }}</p>
          <p v-else class="invoice-due complete">Paid</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: mapGetters('payment', ['paymentDecorated'])
  }
</script>



// WEBPACK FOOTER //
// ShowHeading.vue?090117d7